import { render, staticRenderFns } from "./pricelisthelp.vue?vue&type=template&id=5ab1ae3c&"
import script from "./pricelisthelp.vue?vue&type=script&lang=js&"
export * from "./pricelisthelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ab1ae3c')) {
      api.createRecord('5ab1ae3c', component.options)
    } else {
      api.reload('5ab1ae3c', component.options)
    }
    module.hot.accept("./pricelisthelp.vue?vue&type=template&id=5ab1ae3c&", function () {
      api.rerender('5ab1ae3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Cw9q0kjUAE7z/JS/pricelisthelp.vue"
export default component.exports